<template>
  <CustomDropdown
    maxHeight="300px"
    gap="10px"
    position="start"
    dropdownCSS="p-0"
    v-if="!hideDropdownWrapper"
  >
    <template #trigger>
      <div class="secondary_small gap-1">
        <ThemeImage
          class="size-4"
          :icon="imageNames.ADD_LIST_GREY"
          alt="dropdown_icon"
        />
        Add to List
        <ThemeImage
          class="size-4"
          :icon="imageNames.DROPDOWN_GREY"
          alt="dropdown_icon"
        />
      </div>
    </template>

    <template #default>
      <CreateListDropdownComponent
        ref="createListContentRef"
        v-if="showEntityCreate"
        :source="source"
        :entity-type="entityType"
        @entity-list-created="handleEntityListCreated"
        @go-back="$emit('update:show-entity-create', false)"
      />
      <AddToListDropdownContent
        ref="dropdownContentRef"
        v-else
        :source="source"
        :entity-lists="entityLists"
        :select-mode="selectMode"
        :selected-items="selectedItems"
        @item-click="handleListItemClick"
        @create-new-list="handleCreateNewList"
        :width="width"
      />
    </template>
  </CustomDropdown>

  <div v-else>
    <CreateListDropdownComponent
      v-if="showEntityCreate"
      ref="createListContentRef"
      :source="source"
      :entity-type="entityType"
      @entity-list-created="handleEntityListCreated"
      @go-back="$emit('update:show-entity-create', false)"
    />

    <AddToListDropdownContent
      v-else
      ref="dropdownContentRef"
      :source="source"
      :entity-lists="entityLists"
      :select-mode="selectMode"
      :selected-items="selectedItems"
      @item-click="handleListItemClick"
      @create-new-list="handleCreateNewList"
      :width="width"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import CustomDropdown from "@/src/components/CustomDropdown.vue";
import CreateListDropdownComponent from "@/src/components/CreateListDropdownComponent.vue";
import { xor } from "lodash";
import AddToListDropdownContent from "./AddToListDropdownContent.vue";
import { ref } from "vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import { entityTypes } from "@/src/constants/entityTypeConstants.js";
import store from "@/src/store/index.js";

const props = defineProps({
  source: { type: String, required: true },
  entityLists: { type: Array, default: () => [] },
  showEntityCreate: { type: Boolean, default: false },
  hideDropdownWrapper: { type: Boolean, default: false },
  selectMode: { type: Boolean, default: false },
  selectedItems: { type: Array, default: () => [] },
  width: { type: String, default: '266px' },
});

const emit = defineEmits([
  "entity-list-created",
  "update:show-entity-create",
  "update:selectedItems",
]);

const campaignDetails = computed(
  () => store.getters["callsCampaign/campaignDetails"],
);

const entityType = computed(() => {
  if (props.source === entityTypes.CAMPAIGN) {
    return campaignDetails.value?.entity_type;
  }
  return null;
});

const dropdownContentRef = ref(null);
const createListContentRef = ref(null);

const resetSearch = () => {
  dropdownContentRef.value?.resetSearchState();
  createListContentRef.value?.resetSearchState();
};

const handleListItemClick = (id) => {
  if (!id) return;

  if (props.selectMode) {
    const updatedItems = xor(props.selectedItems, [id]);
    emit("update:selectedItems", updatedItems);
  } else {
    handleEntityListCreated({ listId: id });
  }
};
const handleCreateNewList = () => {
  emit("update:show-entity-create", true);
};

const handleEntityListCreated = (event) => {
  const listId = event.listId || event.id || event;
  const listName = event.list_name || event.name || "";
  emit("entity-list-created", { listId, list_name: listName });

  if (props.selectMode) {
    emit("update:show-entity-create", false);
  }
};

defineExpose({
  resetSearch,
});
</script>
